export default __webpack_public_path__ + "static/media/account-icon.9e1dca78.svg";